export const MINI_PDP_PAGE_LOAD_READY = 'MINI_PDP_PAGE_LOAD_READY';
export const MINI_PDP_PAGE_LOAD_READY_SUCCESS = 'MINI_PDP_PAGE_LOAD_READY_SUCCESS';
export const MINI_PDP_PAGE_LOAD_READY_ONRESET = 'MINI_PDP_PAGE_LOAD_READY_ONRESET';
export const MINI_PDP_CART_ADD_ANALYTICS = 'MINI_PDP_CART_ADD_ANALYTICS';
export const MINI_PDP_PRODUCT_OOS_ANALYTICS = 'MINI_PDP_PRODUCT_OOS_ANALYTICS';
export const MINI_PDP_UPDATE_ITEM_SUCCESS = 'MINI_PDP_UPDATE_ITEM_SUCCESS';
export const MINI_PDP_CARE_PLAN_VIEW_ANALYTICS = 'MINI_PDP_CARE_PLAN_VIEW_ANALYTICS';
export const MINI_PDP_CARE_PLAN_ACCEPT_ANALYTICS = 'MINI_PDP_CARE_PLAN_ACCEPT_ANALYTICS';
export const MINI_PDP_OPEN_MODAL_ANALYTICS = 'MINI_PDP_OPEN_MODAL_ANALYTICS';
export const MINI_PDP_PAGE_LOAD_PRODUCT_OOS = 'MINI_PDP_PAGE_LOAD_PRODUCT_OOS';
